// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Testimonial_testimonial__3UysT","testimonial__text":"Testimonial_testimonial__text__3DFlc","testimonial__heading":"Testimonial_testimonial__heading__3GIEt"};